<!-- src/layouts/BaseLayout.vue -->
<template>
    <div>
        <header id="top_of_all" style="border-bottom: 4px solid #FFCD05;">
    <nav class="navbar navbar-expand-lg navbar-default navbar-light" id="wrap-navbar">
        <div class="container-fluid" style="position: relative" id="wrap-navbar-content">
            <div class="text-center" id="wrap-logo">
                <router-link to="/" style="text-decoration:none;color:black">
                    <img src="/assets/logo.png" style="height: 35px" />
                </router-link>
            </div>
            <div class="d-flex align-items-center">
                <!-- Search icon for mobile - with click handler -->
                <img src="/assets/search_logo.png" alt="Search Logo" style="height: 50px; cursor: pointer;"
                    class="icon-search-mobile" @click="toggleSearchBar" />
                <button class="navbar-toggler" id="button-nav-mobile" type="button" data-bs-toggle="collapse"
                    data-bs-target="#navbarText" aria-controls="navbarText" aria-expanded="false"
                    aria-label="Toggle navigation">
                    <span class="navbar-toggler-icon"></span>
                </button>
            </div>
            <div class="collapse navbar-collapse pt-3" id="navbarText">
                <ul class="navbar-nav ms-auto mb-2 mb-lg-0 pt-md-2">
                    <!-- Search icon for desktop - with click handler -->
                    <img src="/assets/search_logo.png" style="height: 50px; cursor: pointer;" 
                         class="icon-search-desktop" @click="toggleSearchBar" />
                    <li class="nav-item" v-for="(item, index) in navLinks" :key="index">
                        <router-link class="nav-link" :to="item.to" @click="handleNavClick">
                            <p style="vertical-align: middle;text-align: center;"><span class="menu-item-list"
                                    style="margin: 0px;">{{
                                        item.label }}</span><span><img class="img-arrow"
                                        src="/assets/arrow_right.png" /></span>
                            </p>
                        </router-link>
                    </li>
                </ul>
            </div>
        </div>
    </nav>
    
    <!-- Search overlay that appears when search icon is clicked -->
    <div v-if="isSearchVisible" class="search-overlay">
        <div class="search-container">
            <div class="search-header">
                <h4>Pencarian</h4>
                <button class="close-search" @click="toggleSearchBar">×</button>
            </div>
            <div class="search-input-container">
                <input type="text" v-model="searchQuery" class="search-input" placeholder="Masukkan kata kunci..." 
                       @keyup.enter="performSearch" />
                <button class="search-button" @click="performSearch">Cari</button>
            </div>
        </div>
    </div>
</header>

        <!-- CONTENT -->
        <main>
            <slot></slot>
        </main>

        <div class="bfooter">
            <div class="row justify-content-between align-items-center flex-wrap mb-4 p-3 mt-5">
                <div class="col-7">
                    <h5 class="fw-bold text-start">EUROPE LOTTO</h5>
                    <p class="mb-2 small text-start" style="font-size: 10px;">Get the latest info about new games,
                        special
                        promotions, and manymore</p>
                    <div class="d-flex gap-1" id="wrap-icon-social">
                        <a href="#"><i class="fa-brands fa-facebook-f"></i></a>
                        <a href="#"><i class="fa-brands fa-x-twitter"></i></a>
                        <a href="#"><i class="fa-brands fa-instagram"></i></a>
                        <a href="#"><i class="fa-brands fa-youtube"></i></a>
                        <a href="#"><i class="fa-solid fa-envelope"></i></a>
                    </div>
                </div>
               <div class="col-5">
    <img src="/assets/logo.png" alt="Europe Lotto Logo" height="100%" width="100%" class="img-fluid me-auto ms-0" style="padding-right: 15px;" />
</div>
            </div>
        </div>

        <!-- FOOTER -->
        <footer class="bg-primary text-white pt-4 p-2 text-start">
            <div class="container">

                <div class="row text-white small">
                    <div class="col-6 mb-3">
                        <h6 class="fw-bold" style="font-size: 14px;">ABOUT</h6>
                        <ul class="list-unstyled">
                            <li><a href="#" class="text-white text-decoration-none">About Europe Lotto</a></li>
                            <li><a href="#" class="text-white text-decoration-none">Career</a></li>
                            <li><a href="#" class="text-white text-decoration-none">News media</a></li>
                            <li><a href="#" class="text-white text-decoration-none">Division</a></li>
                            <li><a href="#" class="text-white text-decoration-none">Integrity</a></li>
                            <li><a href="#" class="text-white text-decoration-none">Diversity</a></li>
                        </ul>
                    </div>
                    <div class="col-6 mb-3">
                        <h6 class="fw-bold" style="font-size: 14px;">INFORMATION</h6>
                        <ul class="list-unstyled">
                            <li><a href="#" class="text-white text-decoration-none">Business with Us</a></li>
                            <li><a href="#" class="text-white text-decoration-none">Sitemap</a></li>
                            <li><a href="#" class="text-white text-decoration-none">Site Requirements</a></li>
                            <li><a href="#" class="text-white text-decoration-none">Accessibility Policy</a></li>
                            <li><a href="#" class="text-white text-decoration-none">Certification</a></li>
                            <li><a href="#" class="text-white text-decoration-none">Regulatory plan</a></li>
                        </ul>
                    </div>
                    <div class="col-6 mb-3">
                        <h6 class="fw-bold" style="font-size: 14px;">HELP INFORMATION</h6>
                        <ul class="list-unstyled">
                            <li><a href="#" class="text-white text-decoration-none">Help Center</a></li>
                            <li><a href="#" class="text-white text-decoration-none">Lottery Office</a></li>
                        </ul>
                    </div>
                    <!-- <div class="col-6 mb-3">
                        <div class="mt-2">
                            <div><a href="#"><img src="/assets/apple.png" alt="App Store" width="120px"></a></div>
                            <br>
                            <div><a href="#"><img src="/assets/google.png" alt="Google Play" width="120px"></a>
                            </div>
                        </div>
                    </div> -->
                </div>
                <div class="border-top mt-3 pt-3 text-center small">
                    © 2024 Europe Lotto. All rights reserved. Must be old 18 years and over to play.
                </div>
            </div>
        </footer>
    </div>
</template>

<script setup>
import { onMounted } from 'vue'
import $ from 'jquery';

const navLinks = [
    { label: '3D Quick Pick', to: '/3d_result' },
    { label: '4D Result', to: '/4d_result' },
    { label: '5D Result', to: '/5d_result' },
    { label: 'HOW TO CLAIM PRIZE', to: '/claim' },
    { label: 'SCHEDULE', to: '/schedule' },
    { label: 'CHECK', to: '/cek' },
    { label: 'STATISTICS', to: '/statistics' },
    { label: 'ABOUT EUROPE LOTTO', to: '/about' }
]

const handleNavClick = () => {
    $(".navbar-collapse").removeClass("show");
}

onMounted(() => {

})
</script>

<style scoped>
@import "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.1/css/all.min.css";
@import "@/assets/user/style.css";

footer {
    width: 50%;
    margin: 0 auto;
}

.bfooter {
    width: 50%;
    margin: 0 auto;
}

@media (max-width : 767px) {
    footer {
        width: 100%;
    }

    .bfooter {
        width: 100%;
    }
}

#wrap-icon-social i {
    padding: 5px;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    display: flex;
    margin: 0;
    justify-content: center;
    align-items: center;
    background-color: #1F357C;
}

#wrap-icon-social a {
    color: white;
    font-size: 14px;
    text-decoration: none;
}

footer {
    background: linear-gradient(to bottom, #1a2a6c, #1a2a6c, #000);
}

footer li {
    margin-bottom: 10px;
}
</style>

<style>
/* Styles for search overlay */
.search-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    z-index: 1000;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    padding-top: 100px;
}

.search-container {
    width: 80%;
    max-width: 600px;
    background-color: white;
    border-radius: 5px;
    overflow: hidden;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.3);
}

.search-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 20px;
    background-color: #f8f8f8;
    border-bottom: 1px solid #ddd;
}

.search-header h4 {
    margin: 0;
    color: #333;
}

.close-search {
    background: none;
    border: none;
    font-size: 24px;
    cursor: pointer;
    color: #555;
}

.search-input-container {
    padding: 20px;
    display: flex;
}

.search-input {
    flex: 1;
    padding: 10px 15px;
    border: 1px solid #ddd;
    border-radius: 4px 0 0 4px;
    font-size: 16px;
}

.search-button {
    padding: 10px 20px;
    background-color: #FFCD05;
    color: black;
    border: none;
    border-radius: 0 4px 4px 0;
    cursor: pointer;
    font-weight: bold;
}

.search-button:hover {
    background-color: #e0b504;
}

/* Make search icons interactive */
.icon-search-mobile, .icon-search-desktop {
    cursor: pointer;
    transition: transform 0.2s;
}

.icon-search-mobile:hover, .icon-search-desktop:hover {
    transform: scale(1.1);
}
</style>

<script>
export default {
  data() {
    return {
      isSearchVisible: false,
      searchQuery: '',
      navLinks: [
        // your navigation links go here
        { label: 'Beranda', to: '/' },
        { label: 'Tentang Kami', to: '/about' },
        // add more as needed
      ]
    }
  },
  methods: {
    toggleSearchBar() {
      this.isSearchVisible = !this.isSearchVisible;
      if (!this.isSearchVisible) {
        this.searchQuery = ''; // Clear search when closing
      }
    },
    performSearch() {
      if (this.searchQuery.trim()) {
        // Implement your search logic here
        console.log('Searching for:', this.searchQuery);
        
        // Example: Navigate to search results page with query parameter
        this.$router.push({
          path: '/search',
          query: { q: this.searchQuery }
        });
        
        // Close the search overlay after searching
        this.toggleSearchBar();
      }
    },
    handleNavClick() {
      // Your existing nav click handler
    }
  }
}
</script>
